/**
 * Audio Controller Class
 *
 * Handles the audio components
 *
 * Can be called by example: musicManager.onFreespinsIntro();
 *
 */
musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.wasInFreespins = false;
musicManager.inBaseGameModifier = false;
musicManager.inBigWin = false;
musicManager.musicLevel = 1;
musicManager.maxMusicVolume = 0.7;

musicManager.ALLOFFLEVEL = [false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false];
musicManager.SINGLEWINLEVEL = [false, true, false, false];
musicManager.MULTIWINLEVEL = [false, false, true, false];
musicManager.REALLYBIGWINLEVEL = [false, false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false];
musicManager.FREESPINS_BASE = [true, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInActive = false;
musicManager.fadeOutActive = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInActiveFS = false;
musicManager.fadeOutActiveFS = false;

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1000;
  musicManager.fadeBaseTimeOut = 1000;

  musicManager.fadeLevelTimeIn = 300;
  musicManager.fadeLevelTimeOut = 500;

  musicManager.fadeBigWinTimeIn = 250;
  musicManager.fadeBigWinTimeOut = 250;

  musicManager.fadeSymWinTimeIn = 300;
  musicManager.fadeSymWinTimeOut = 300;

  musicManager.baseMusic = [
    "dm_theme_level_0_v1",
    "dm_theme_level_1_v1",
    "dm_theme_level_2_v1",
    "dm_theme_level_3_v1",
  ];

  musicManager.basePlaying = [false, false, false, false, false];

  musicManager.baseID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = [
    "dm_fs_theme_level_1_v1",
    "dm_fs_theme_level_2_v1",
    "dm_fs_theme_level_3_v1",
  ];

  musicManager.fsPlaying = [false, false, false, false];

  musicManager.freeSpinsID = [];
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(
      soundManager.play(musicManager.freeSpinsMusic[j])
    );
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.fadeLevels(musicManager.IDLELEVEL, 0, 0, 1, 0);
};

musicManager.onSymbolWinlineStart = function () {
  if (musicManager.inFreespins) {
    musicManager.previouslyPlayingBeforeFade = musicManager.fsPlaying;
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut,
      1,
      0.3
    );
  } else {
    musicManager.previouslyPlayingBeforeFade = musicManager.basePlaying;
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut,
      1,
      0.3
    );
  }
};

musicManager.onSymbolWinlineEnd = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeIOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut,
      1,
      0.3
    );
  }
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameStart = function () {
  musicManager.idle = false;
  musicManager.stepDownTimer = undefined;
  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;
    musicManager.fadeLevels(
      musicManager.SPINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  }
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;

  var duration = musicManager.wasInFreespins ? 1800 : 200;

  musicManager.stepDownTimer = timerManager.addTimer(
    duration,
    undefined,
    () => {
      musicManager.fadeLevels(
        musicManager.IDLELEVEL,
        musicManager.fadeBaseTimeIn,
        musicManager.fadeBaseTimeOut,
        1,
        0
      );
    }
  );
};

musicManager.stepDown = function () {
  if (musicManager.basePlaying === musicManager.REALLYBIGWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.MULTIWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.SINGLEWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(
      4000,
      undefined,
      musicManager.stepDown
    );

    musicManager.fadeLevels(
      musicManager.SPINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    timerManager.stop(musicManager.stepDownTimer);

    musicManager.fadeLevels(
      musicManager.IDLELEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play("bigWinLoop");

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    // /musicManager.stepDownTimer  = timerManager.addTimer(4000, undefined , musicManager.stepDown);
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut,
      1,
      0
    );
  }
};

musicManager.fadeBigWin = function (newVolume) {
  soundManager.setVolume(newVolume, musicManager.bigWinID);
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (
  levels,
  fadeInTime,
  fadeOutTime,
  volIn,
  volOut
) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeLevelsOutFinished(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  musicManager.fadeInActive = false;
  musicManager.fadeOutActive = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
      musicManager.fadeInActive = true;
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
      musicManager.fadeOutActive = true;
    }
  }

  musicManager.fadeInTimer = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsIn,
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume)
  );
  musicManager.fadeOutTimer = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOut,
    musicManager.fadeLevelsOutFinished(volOut)
  );

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeLevelsInFinishedFS();
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeLevelsOutFinishedFS();
  }

  // at end as we may not have a channel currently playing - musicManager.fsPlaying = levels;
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  musicManager.fadeInActiveFS = false;
  musicManager.fadeOutActiveFS = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeInActiveFS = true;
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeOutActiveFS = true;
    }
  }

  musicManager.fadeInTimerFS = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInFS,
    musicManager.fadeLevelsInFinishedFS
  );
  musicManager.fadeOutTimerFS = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutFS,
    musicManager.fadeLevelsOutFinishedFS
  );

  musicManager.fsPlaying = levels;
};

// BASE VERSIONS

musicManager.fadeLevelsIn = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(
      progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeIn[i]
    );
  }
};

musicManager.fadeLevelsOut = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOut[i]
    );
  }
};

musicManager.fadeLevelsInFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeIn[i]);
  }
  musicManager.fadeInActive = false;
};

musicManager.fadeLevelsOutFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeOut[i]);
  }

  musicManager.fadeOutActive = false;
};

// FREESPIN VERSIONS
musicManager.fadeLevelsInFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(
      progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeInFS[i]
    );
  }
};

musicManager.fadeLevelsOutFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOutFS[i]
    );
  }
};

musicManager.fadeLevelsInFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume,
      musicManager.soundsToFadeInFS[i]
    );
  }

  musicManager.fadeInActiveFS = false;
};

musicManager.fadeLevelsOutFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(0, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fadeOutActiveFS = false;
};

musicManager.restartBaseMusic = function () {
  musicManager.fadeLevels(
    musicManager.IDLELEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );
};

musicManager.restartFreeSpins = function () {
  musicManager.fadeFSLevels(
    musicManager.freeSpinsLevel,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );
};

musicManager.onFreespinsIntro = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(
    musicManager.ALLOFFLEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );
  musicManager.playing = false;
};

musicManager.onFreespinsStart = function () {
  // Here we stop the freespins intro music and play the freespins standard music
  timerManager.stop(musicManager.stepDownTimer);

  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  musicManager.fadeFSLevels(
    musicManager.freeSpinsLevel,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.freeSpinsNextLevel = function () {
  var changed = false;

  if (musicManager.freeSpinsLevel === musicManager.FREESPINS_BASE) {
    musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
    changed = true;
  } else if (musicManager.freeSpinsLevel === musicManager.FREESPINS_LEVEL1) {
    musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL2;
    changed = true;
  }

  if (changed) {
    musicManager.fadeFSLevels(
      musicManager.freeSpinsLevel,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.onFreespinsEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  soundManager.play("gameEnd");
  musicManager.inFreespins = false;
  musicManager.wasInFreespins = true;
  musicManager.fadeFSLevels(
    musicManager.FREESPINS_ALLOFF,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut
  );
};

musicManager.onFreespinsLostGambleEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;
  musicManager.fadeLevels(
    musicManager.IDLELEVEL,
    musicManager.fadeBaseTimeIn,
    musicManager.fadeBaseTimeOut,
    1,
    0
  );
};

musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);
